import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const messageInputButtonStyles = tv({
    slots: {
        button: `
      iris:group
      iris:flex
      iris:size-(--comp-size-box-message-input-button)
      iris:items-center
      iris:justify-center
      iris:rounded-(--comp-size-radius-message-input-button)
      iris:bg-(--comp-color-background-message-input-button-rest)     
    `,
        icon: `
      iris:size-(--comp-size-icon-message-input)
      iris:text-(--comp-color-content-message-input-button-rest)
      iris:transition-all
      iris:duration-(--comp-motion-duration-message-input)
      iris:ease-(--comp-motion-easing-message-input)
    `,
    },
    variants: {
        variant: {
            send: {},
            stop: {},
        },
        inverse: {
            true: {
                button: focusStyles.inverse,
                icon: `
        iris:text-(--comp-color-content-message-input-button-inverse-rest)
        `,
            },
            false: { button: focusStyles.default },
        },
        disabled: {
            true: {
                button: `
        iris:cursor-not-allowed
        iris:bg-(--comp-color-background-message-input-button-disabled)
        iris:opacity-(--sem-opacity-interactive-disabled)
        `,
                icon: `
        iris:text-(--comp-color-content-message-input-button-disabled)
        `,
            },
            false: {
                button: `
        iris:cursor-pointer
        `,
                icon: `
        iris:group-hover:text-(--comp-color-content-message-input-button-hover)
        iris:group-active:text-(--comp-color-content-message-input-button-pressed)
      `,
            },
        },
    },
    compoundVariants: [
        {
            inverse: true,
            disabled: false,
            class: {
                icon: `
    
        iris:group-hover:text-(--comp-color-content-message-input-button-inverse-hover)
        iris:group-active:text-(--comp-color-content-message-input-button-inverse-pressed)
       `,
            },
        },
        {
            inverse: true,
            disabled: true,
            class: {
                icon: `
            iris:text-(--comp-color-content-message-input-button-inverse-disabled)
            `,
            },
        },
    ],
    defaultVariants: {
        variant: "send",
        inverse: false,
        disabled: false,
    },
});

export { messageInputButtonStyles as default };
